export default __webpack_public_path__ + "static/media/doma-baznica.66c74a3a.jpg";